module.exports = __webpack_public_path__ + "img/logo.4fcc35e2.png";